import { getQueryStringParameters } from 'owa-querystring';

export default function doAuthRedirect(loc: Location) {
    let query = getQueryStringParameters(loc);

    if (query.authRedirect === undefined) {
        let prefix = loc.search.length > 0 ? loc.search.substring(1) + '&' : '';
        loc.search = '?' + prefix + 'authRedirect=true';
    }
}
